import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { NomsHardman } from '@shared/src/controllers/NomsHardman';
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';
import { RouteController } from '@shared/src/controllers/route/route.controller';
import { HTags } from '@shared/src/datatypes/HTags';
import { RouteCardDto } from '@shared/src/dtos/route/RouteCardDto';
import { HardmanProducts } from '@shared/src/enums/HardmanProducts';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'shared-route-changemarks',
  templateUrl: './shared.route.changemarks.component.html',
  styleUrls: ['./shared.route.changemarks.component.scss'],
})
export class SharedRouteChangeMarksComponent {

  public useIonic: boolean = false;
  private valueChanged$ = new Subject<void>();

  constructor(@Inject('HomeController') public homeController: HomeController,
    private openRouteController: OpenRouteController,
    private routeController: RouteController) {

    if (homeController.useIonic)
      this.useIonic = homeController.useIonic();

    this.hascarrier = this.homeController.hasProduct(HardmanProducts.carrier);
    this.hasshipper = this.homeController.hasProduct(HardmanProducts.shipper);

    this.valueChanged$.pipe(
      debounceTime(500)
    ).subscribe(() => {
      this.updateBackend();
    });
  }

  public hascarrier: boolean = false;
  public hasshipper: boolean = false;


  @Input() public showPadding: boolean = false;

  @Input() public readonly: boolean = false;

  @Input() public showtitle: boolean = false;
  @Input() public showalltags: boolean = false;

  public __route: RouteCardDto;
  @Input()
  public set route(value: RouteCardDto) {
    if (this.__route === value)
      return;
    this.__route = value;
    if (this.__route == null) {
      this.__routeId = 0;
    } else {
      this.__routeId = value.routeId;
    }
  }
  public get route(): RouteCardDto {
    return this.__route;
  }

  public __routeId: number;
  @Input()
  set routeId(value: number) {
    if (this.__routeId === value)
      return;
    this.__routeId = value;
    this.loadRouteData();
  }
  get routeId(): number {
    return this.__routeId;
  }


  public loadRouteData() {
    if (!this.routeId)
      return;

    this.routeController.getRoute(this.routeId).subscribe(route => {
      this.route = route;
      this.routeUpdated.next(this.route);
      this.internalTagsBase();
    });
  }
  @Output() routeUpdated: EventEmitter<RouteCardDto> = new EventEmitter();
  public onRouteUpdated(value: RouteCardDto) {
    if (this.route == null || value == null || this.route.routeId === value.routeId)
      this.route = value;

    this.routeUpdated.next(value);
  }

  @Output() public valueChange: EventEmitter<any> = new EventEmitter<any>();
  public tagsBase: HTags = new HTags;
  public internalTagsBase() {
    this.tagsBase = HTags.buildFromDto(this.route.internalTags);

    if (this.route.internalTags) {
      this.delayed = HTags.contains(this.route.internalTags, NomsHardman.DELAYED);
      this.notready = HTags.contains(this.route.internalTags, NomsHardman.NOTREADY);
      this.problem = HTags.contains(this.route.internalTags, NomsHardman.PROBLEM);
    } else {
      this.delayed = false;
      this.notready = false;
      this.problem = false;
    }
  }
  public updateValue() {
    this.valueChanged$.next();  // dispara el subject
  }
  public updateBackend() {
    if (!this.tagsBase) {
      this.tagsBase = new HTags();
    }

    this.tagsBase.remove(NomsHardman.DELAYED);
    this.tagsBase.remove(NomsHardman.NOTREADY);
    this.tagsBase.remove(NomsHardman.PROBLEM);

    if (this.delayed) this.tagsBase.add(NomsHardman.DELAYED);
    if (this.notready) this.tagsBase.add(NomsHardman.NOTREADY);
    if (this.problem) this.tagsBase.add(NomsHardman.PROBLEM);

    this.openRouteController.setManualMarks(this.__route.routeId, this.tagsBase)
      .subscribe(data => {
        this.valueChange.next(this.__route);
      });
  }



  public delayed: boolean = false;
  public notready: boolean = false;
  public problem: boolean = false;

  save() {

  }

  public pretty(value) {
    return JSON.stringify(value);
  }
}
